/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { observer } from 'mobx-react';
import React, { ReactElement } from 'react';
import { Box, Button, Divider, Grid, Paper } from '@mui/material';
import { GridLegacy } from '@mui/material';
import { Image, ThumbDown, ThumbUp } from '@mui/icons-material';
import { Entry, ENTRY_REVIEW_STATE } from '../../../../../types/course/Entry';
import clsx from 'clsx';
import { EntriesReviewViewModel } from '../EntriesReviewViewModel';
import EntryBoxViewStyles from './EntryBoxViewStyles';

interface Props {
	entry: Entry;
	viewModel: EntriesReviewViewModel;
}

const EntryBoxView = observer((props: Props): ReactElement => {
	const { entry, viewModel } = props;
	const { classes } = EntryBoxViewStyles();

	console.log('EntryBoxView entry: ' + JSON.stringify(entry));

	return (
		<GridLegacy item md={3} xs={4}>
			<Paper>
				<Box
					onClick={() => viewModel.setEntry(entry)}
					className={clsx(classes.image, {
						[classes.approved]: entry.state === ENTRY_REVIEW_STATE.APPROVED,
						[classes.rejected]: entry.state === ENTRY_REVIEW_STATE.REJECTED,
					})}>
					{entry.imageUrl ? (
						<img src={entry.imageUrl} alt='' />
					) : (
						<Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
							<Image />
						</Box>
					)}
				</Box>
				<GridLegacy container alignItems={'center'} justifyContent={'center'} height={44}>
					{entry.state === ENTRY_REVIEW_STATE.PENDING && (
						<>
							<GridLegacy item xs>
								<Button
									fullWidth={true}
									onClick={() => viewModel.updateReviewState(entry.id, ENTRY_REVIEW_STATE.REJECTED)}>
									<ThumbDown style={{ width: '16px', height: '16px', color: 'rgba(0,0,0, 0.6)' }} />
								</Button>
							</GridLegacy>
							<Divider orientation='vertical' flexItem />
							<GridLegacy item xs>
								<Button
									fullWidth={true}
									onClick={() => viewModel.updateReviewState(entry.id, ENTRY_REVIEW_STATE.APPROVED)}>
									<ThumbUp style={{ width: '16px', height: '16px', color: 'rgba(0,0,0, 0.6)' }} />
								</Button>
							</GridLegacy>
						</>
					)}
					{entry.state === ENTRY_REVIEW_STATE.APPROVED && (
						<Box>
							<ThumbUp style={{ width: '16px', height: '16px' }} color='success' />
						</Box>
					)}
					{entry.state === ENTRY_REVIEW_STATE.REJECTED && (
						<Box>
							<ThumbDown style={{ width: '16px', height: '16px' }} color='error' />
						</Box>
					)}
				</GridLegacy>
			</Paper>
		</GridLegacy>
	);
});

export default EntryBoxView;
